import { upperFirst } from "lodash";
import { AbstractDate } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import {
  mmt,
  months,
  monthsShort,
  now,
  setLocale,
  week,
  weekYear,
  weekdays,
  weekdaysMin,
} from "@tootools/date";

export enum Format {
  Classic = "L",
  OnlyDay = "D",
}

let __locale: Locale | "en";

function getValidLocal(locale: Locale) {
  return locale === Locale.English ? "en" : locale;
}

export function tz(d: AbstractDate, timezone: Timezone = "UTC") {
  return mmt(d).tz(timezone);
}

export function today(timezone: Timezone = "UTC") {
  return now(timezone);
}

export function travel(locale: Locale) {
  const _locale = getValidLocal(locale);
  if (__locale !== _locale) {
    __locale = _locale;
    setLocale(_locale);
  }
  return _locale;
}

export function formatDate(date: AbstractDate, locale: Locale, format: string) {
  return mmt(date).locale(getValidLocal(locale)).format(format);
}

export function getMonths(locale: Locale, shorten?: boolean) {
  travel(locale);
  return shorten ? monthsShort() : months();
}

export function getMonth(
  locale: Locale,
  date: AbstractDate,
  shorten?: boolean
) {
  const months = getMonths(locale, shorten);
  return upperFirst(months[mmt(date).month()]);
}

export function getWeek(date: AbstractDate, locale: Locale) {
  travel(locale);
  return week(date);
}

export function getWeekYear(date: AbstractDate, locale: Locale) {
  travel(locale);
  return weekYear(date);
}

export function getWeekDay(
  locale: Locale,
  date: AbstractDate,
  shorten?: boolean
) {
  const weekdays = getWeekdays(locale, shorten);
  return upperFirst(weekdays[mmt(date).weekday()]);
}

export function getWeekdays(locale: Locale, shorten?: boolean) {
  travel(locale);
  return shorten ? weekdaysMin() : weekdays();
}

export function format(
  date: AbstractDate,
  timezone: Timezone = "UTC",
  format: Format | string = Format.Classic
) {
  return tz(date, timezone).format(format);
}
